import { isUndefined, omitBy } from "lodash-es";

type DefinedKeys<T extends object> = {
  [K in keyof T]-?: undefined extends T[K] ? never : K;
}[keyof T];

type MaybeUndefinedKeys<T extends object> = {
  [K in keyof T]-?: undefined extends T[K] ? K : never;
}[keyof T];

export type Undefinedless<T extends object> = Pick<T, DefinedKeys<T>> &
  Partial<{
    [K in MaybeUndefinedKeys<T>]: Exclude<T[K], undefined>;
  }>;

export function undefinedless<T extends object>(value: T): Undefinedless<T> {
  return omitBy(value, isUndefined) as Undefinedless<T>;
}
